const lightTheme = {
  white: '#ffffff',
  black: '#000000',
  tilesTitleClr: '#a0aec0',
  tilesValueClr: '#2d3748',
  sublimitIconClr: '#88ECC9',
  upcomingRenewalsIconClr: '#A3C0FF',
  activeIconClr: '#A6DDFF',
  expiredIconClr: '#E4D0FF',
  closedIconClr: '#FFB1B1',
  summaryCardBoxShadow: '#00000005',
  blackButtonHoverColor: '#535353',
  deleteBtnClr: '#ED5F5F',
  deleteBtnHvrClr: '#F60606',
  //DropDownThemeColors
  dropDownLabelColor: '#475467',
  dropDownRequiredColor: '#f44336',
  dropDownBorderColor: '#a3a3a3',
  dropDownFocusBorderColor: '#2563eb',
  dropDownMenuBorderColor: '#e5e7eb',
  dropDownPlaceholderColor: '#A0AEC0',
  dropDownBackGroundColor: '#dee4ea',
  dropDownMenuScrollThumbColor: '#dee4ea',
  //dropdownend
  viewBtnBg: '#A6B5CE',
  saveBtnBg: '#3085fe',
  saveBtnHoverBg: '#09659f',
  saveBtnHoverBorderColr: '#5fb7ff',
  addSubmitBtnBG: '#209bff',
  uploadBlackBtnBorderColr: '#838181',
  uploadBlackBtnBg: '#f9fafb',
  blackHoverBtnBg: '#fffdfd',
  deleteBg: '#ed5f5f',
  deleteHoverBg: '#FF4E4E',
  deleteHoverBorderClr: '#ff7e7e',
  clearBtnClr: '#040404',
  exportBtnBorderColr: '#1f1919',
  UploadDocBoderClr: '#A6B5CE',
  UploadDocBoderHoverClr: '#7070708F',
  viewbtnHoverClr: '#E7EAF0',
  exportBtnHoverBg: '#535353',
  exportBtnTextClr: '#535353',
  greyBtnTextClr: '#474747',
  datePickerBorderClr: '#e2e8f0',
  errorStarRed: '#f90b0b',
  datePickerTitle: '#2d3748',
  datePickerNonActiveInputClr: '#2D3748',
  datePickerDisabledInputClr: '#101828',
  calendarDaysClr: '#212529',
  calendarDaysClrHvr: '#eeeeee',
  calendarDaysHeaderClr: '#6c757d',
  calendarActiveClr: '#0d6efd',
  datepickerInnerClr: '#101828',
  datepickerInputSpan: 'rgb(28 28 28)',
  datepickerSrvValidationMsg: 'rgb(244 67 54)',
  calendarPopupInfinitBoxShadowClr: 'rgb(255 255 255)',
  disabledBrdrClr: '#e2e8f0',
  disabledBgClr: '#fafafa',
  popupTextareaLabel: '#7182a0',

  //Table grid theme start

  tableBg: 'rgba(255, 255, 255, 1)',
  tableHeadBorder: 'rgba(226, 232, 240, 1)',
  tableHeadText: 'rgba(160, 174, 192, 1)',
  tableTrEvenBg: 'rgb(245 246 246)',
  white81: 'rgb(255 255 255 / 81%)',
  tableCommonText: 'rgba(45, 55, 72, 1)',
  tablePaginationColor: '#7593CF',
  tablePaginationBg: '#1e253e',
  tablePaginationSelectedBorder: '#fc8f00',
  tablePaginationSelectedColor: '#ffffff',
  expandedGridBg: 'rgba(230, 230, 230, 1)',
  expandedGridHeadBorder: 'rgba(211, 211, 211, 1)',
  expandedGridHeadColor: 'rgba(149, 149, 150, 1)',
  expandedGridHeadInnerColor: '#959596',
  expandedGridEvenBg: 'rgba(223, 223, 223, 1)',
  paginationButtonBorder: '#e9e9e9',
  paginationGoButtonBorder: '#ccc',
  paginationGoButtonBg: '#f5f5f5',
  paginationInfoText: '#000000',
  gridCommonBorder: '#e5eef3',
  gridScrolltrack: '#323542',
  gridScrollthumb: '#828492',
  gridContentStickyBorder: '#3a2d4c',

  //table theme end

  summaryCardBoxShadowV2: 'rgba(0, 0, 0, 0.15)',
  summaryCardBrdrClrV2: '#f2f3f3',
  tilesTitle: 'rgba(104, 104, 104, 1)',
  tilesActiveClr: 'rgba(54, 192, 137, 1)',
  tilesExpiredClr: '#ED5F5F',
  tilesInactiveClr: 'rgba(237, 95, 95, 1)',
  summaryTilesSvgBg: 'rgba(242, 242, 242, 1)',
  //Checkbox theme colors
  checkBoxBackGroundColor: '#3085fe',
  checkBoxBorderColor: '#00000040',
  checkBoxFocusBorderColor: '#0000ff',
  checkBoxCheckBorderColor: '#6dc5ce ',
  //Checkbox theme colors end

  cancelButtonTxtClr: '#A0AEC0',
  warningPopupIcnBg: '#F5F7F8',
  warningPopupMainTitleClr: '#282424',
  warningPopupReasonClr: '#7182A0',
  discardBgHvrClr: '#433E3E',
  discardCancelBtnBgHvr: '#433E3E',
  warningPopupIconBrdrClr: '#EAEEF2',
  textareaPlaceholder: 'rgba(181, 181, 181, 1)',
  //NavBar Theme Colors
  navBarBorderColor: '#eaecf0',
  navBarLabelColor: '#0458ff',
  navBarDefaultBgColor: '#c4c4c440',
  navBarOnlineColor: '#12b76a',
  //NavBar Theme Colors end

  //LayOut Theme Colors
  layoutPageScrollColor: '#ebe8e8',
  layoutPageScrollThumbColor: '#d2d3d9',
  //LayOut Theme Colors end

  //Sidebar Theme Colors
  sideBarBorderColor: '#eaecf0',
  sideBarSearchWrapperBorderClr: '#d0d5dd',
  sideBarSelectedItemBgClr: '#efefef',
  sideBarItemTextClr: '#292929',
  //Sidebar Theme Colors end

  // table grid theme colors
  tableGridStatusGreen: '#36C089',
  sublimitCardBg: 'rgba(230, 230, 230, 1)',
  sublimitCardBrdrClr: '#e5f0ff',
  mainCardBg: 'rgba(245, 246, 246, 1)',
  mainCardBrdr: '#aaaaaa',
  //pieChart Theme Colors
  pieChartBorderClr: '#e5eef3',
  pieChartLableClr: '#2d3748',
  pieChartSliceBlueClr: '#3B00ED',
  pieChartSliceGreyClr: '#D9D9D9',
  pieChartGreenClr: '#36C089',
  pieChartBoxShadowClr: 'rgba(0, 0, 0, 0.05)',
  //pieChart Theme Colors end

  //Text field theme
  textFieldTextColor: '#292929',
  textFieldBorderColor: '#caced8',
  //Text field theme end

  //Add Facility Page
  addFacilityBackGroundColor: '#F9FAFB',
  addFacilityBorderColor: '#e5eef3',
  addFacilityBoxShadowColor: '#00000005',
  addFacilityHeaderTitleColor: '#101828',
  addFacilityHeaderSubTitleColor: '#475467',
  addFacilityHeaderBorderColor: '#E2E8F0',
  //Add Facility Page end
  //Common field theme
  textFieldDisableTextColor: '#A0AEC0',
  //Common field theme end
  //multiselect field theme start
  multiSelectBorderClr: '#a6b5ce',
  multiCheckBoxBorder: '#7182a0',
  multiSelectContainerBorderClr: '#ACBAD1',
  listBgClr: '#fffdfd',
  listHoverClr: '#dbd8d8 ',
  searchInputClr: '#475467',
  selectCountSpanClr: '#ffffffb0',
  //multiselect field theme end

  //Upload document theme
  uploadDocumentBgColor: '#d7dee3',
  uploadDocumentBoxShadowColor: '#00000040',
  uploadDocumentTitleColor: '#282424',
  uploadDocumentFileUploadBgColor: '#ececec',
  uploadDocumentFileUploadBtnColor: '#4a4a4a',
  uploadDocumentFileUploadImageBgColor: '#d9d9d9',
  uploadDocumentFileUploadTypeColor: '#575353',
  uploadDocumentFileUploadSizeColor: '#5753538a',
  uploadDocumentDropDownBorderColor: '#a6b5ce',
  uploadDocumentDropDownContentColor: '#a6b5ce',
  //Upload document theme end
  //Custom Toast theme
  errorBgClr: '#fdedef',
  errorBrdrClr: '#ea3e2f',
  successBgClr: '#b6eacd',
  successBrdrClr: '#00b152',
  warningBgClr: '#fde5c6',
  warningBrdrClr: '#f6a829',
  infoBgClr: '#c2edfe',
  infoBrdrClr: '#0267ee',
  // tooltip theme
  tooltipBgClr: '#181b32',

  statusActive: '#36C089',
  statusInActive: '#323232',
  statusClosed: '#ED5F5F',
  statusOverDue: '#eb8510',

  //skelton loader
  skeletonBaseColor: '#b7bdbe2b',
  skeletonHighlightColor: '#f5f5f58f',
  //skelton loader end
  //Facility Card View start
  cardBorderClr: '#e5eef3',
  cardLabelClr: '#718096',
  cardValueClr: '#2d3748',
  cardTotalAmountClr: '#148e6c',
  boxShadowClr: '#00000005',
  uploadDocumentLableClr: '#209BFF',
  infoLabelClr: '#acacac',
  tabTextClr: '#101317',
  tabBorderClr: '#e5eef3',
  tabBoxShadowClr: '#00000040',
  facilityDetailsCardBxShadowClr: 'rgba(0, 0, 0, 0.25)',
  //Facility Card View end
  //mobileAddFacility Theme
  mobileAddFacilityTitleClr: '#292D32',
  mobileAddFacilitySubTitleClr: '#475467',
  //mobileAddFacility Theme end
  //custom date-range picker light theme start
  customDateRangeSelectorBg: 'rgba(255, 255, 255, 1)',
  customDateRangeSelectorTxtClr: '#344054',
  customDateRangeSelectorValueTxtClr: '#101828',
  customDateRangeSelectorWeekDays: 'rgba(115, 115, 115, 1)',
  customDateRangeSelectorDays: '#344054',
  customDateRangeSelectorNeighboringMonthDays: '#667085',
  customDateRangeSelectorDaysHvr: '#0000000a',
  customDateRangeSelectorValueBrdrClr: '#D0D5DD',
  customDateRangeSelectorBrdrClr: '#D0D5DD',
  customDateRangeSelectorButtonBrdrClr: '#D0D5DD',
  customDateRangeSelectorButtonClr: '#344054',
  customDateRangeSelectorButtonHvrBgClr: '#F9FAFB',
  customDateRangeSelectorButtonHvrClr: '#1D2939',
  customDateRangeSelectorButtonSecndBgClr: 'rgba(0, 0, 0, 1)',
  customDateRangeSelectorButtonSecndClr: '#FFFFFF',
  customDateRangeSelectorButtonSecndHvrBgClr: '#2e2a2a',
  customDateRangeSelectorBorder: '#E6E9EC',
  customDateRangeSelectorHyphenClr: '#667085',
  customDateRangeSelectorTodayDot: '#98A2B3',
  customDateRangeSelectorActiveTileBg: 'rgba(204, 204, 204, 1)',
  customDateRangeSelectorTileFocusedClr: '#FFFFFF',
  customDateRangeSelectorTileActiveClr: '#344054',
  customDateRangeOverViewDateRangeBrdrClr: '#ededef',
  customDateRangeOverViewDateRangeClr: '#101828',
  customDateRangeOverViewDateRangeIconClr: '#101828',
  customDateRangeCancelBtnClr: '#000000',
  customDateRangeCancelBtnBorderClr: '#D9D9D9',
  customDateRangeNavTextColor: '#000000',
  customDateRangeMainBg: 'rgba(255, 253, 253, 1)',
  customDateRangeMainBorder: 'rgba(166, 181, 206, 1)',
  customDateRangeMainSelectedBg: '#000000',
  customDateRangeMainSelectedColor: '#fff',
  customDateRangeFooterColor: '#000000',
  customDateRangeCalenderBorder: '#0000001a',
  customDateRangeDateValueBg: '#fafafa',
  customDateRangeDateValueBorder: '#cccccc',
  customDateRangeDateValueColor: '#000000',
  customDateRangeNavBorder: '#e3e0e0',
  customDateRangeCancelBtnHvrBg: '#F5F5F5',

  //custom date-range picker light theme end

  // Facility list
  facilityListToggleBtn: '#1d1c1c',
  facilityListWelcomeBrdrClr: '#e5eef3',
  facilityListLabelClr: '#2D3748',
  facilityListMobileBrdrBtmClr: '#e2e8f0',

  //history list starts
  historyNameClr: '#2D3748',
  actionLableClr: '#0b65ff',
  timeLableClr: '#a0aec0',
  lineBackgroundClr: '#e0e1e2',
  detailsBorderClr: '#e1e3e8 ',
  historyBorderClr: '#e5eef3',
  historyBoxShadow: 'rgba(0, 0, 0, 0.05)',
  mobileTimeLableClr: '#565973',
  linearGradientClr:
    '90deg, rgba(224, 225, 226, 0) 0%, #e0e1e2 49.52%, rgba(224, 225, 226, 0.15625) 99.04%',
  //expiry alert starts
  alertBackgroundClr: '#fa0e0e14',
  alertBorderClr: '#ff2b2b80',
  alertlabelClr: '#ed3a3a',
  //expiry alert ends
  detailCardBackGroundClr: '#F9F9F9',

  //mobilefacilitylistchary theme start
  chartBorder: '#8e8e8e',
  headingColor: '#acacac',
  chartParaColor: '#2d3748',
  backdropBg: 'rgb(0 0 0 / 65%)',
  chartBefore: '#dddd',
  chartAfter: '#e2e8f0',
  chartTitle: '#a0aec0 ',
  chartAmount: '#039c5f',
  chartTrackBg: '#D7D9DB',
  chartLabelColor: '#000',
  mobileFundedChartColor: '#3B00ED',
  mobileNonFundedChartColor: '#36C089',

  //mobilefacilitylistchary theme end

  //HISTORY DETAILS PAGE START
  historyMobileCardBg: '#f8fbff',
  historyMobileCardBrdrClr: 'rgba(112, 112, 112, 0.38)',
  histroyDetailsTblHderBg: '#f5f6f6',
  historyDetailsValueClr: 'rgba(45, 55, 72, 1)',
  historyDetailsTdBrdrClr: 'rgba(226, 232, 240, 1)',
  //HISTORY DETAILS PAGE END

  // Addloan theme
  addInstallmentBtnBorder: '#3085FE',
  addInstallmentBtnText: '#3085FE',
  addInstallmentBtnBg: '#F9FAFB',
  customDateSplitText: 'rgba(0, 0, 0, 0.93)',
  customDateGridheader: 'rgba(246, 248, 252, 1)',
  customDateGridTdBorder: 'rgba(226, 232, 240, 1)',
  customDateGridTdEvenBg: 'rgba(246, 248, 252, 1)',
  customDateGridTdOddBg: 'rgba(249, 250, 251, 1)',
  styledCardBg: 'rgba(248, 251, 255, 1)',
  styledCardBgBorder: 'rgba(112, 112, 112, 0.38)',
  styledCardLabel: 'rgba(172, 172, 172, 1)',
  styledFieldBlueBorder: '#209bff',
  styledFieldDisabledBorder: 'rgba(226, 232, 240, 1)',
  styledFieldReadOnlyBorder: 'rgba(226, 232, 240, 1)',

  //close loan popu
  closeLoanTitleClr: 'rgba(0, 0, 0, 1)',
  closeLoanCheckboxButtonBg: 'rgba(248, 248, 248, 1)',
  closeLoanCheckboxLabelClr: 'rgba(0, 0, 0, 1)',
  closeLoanCheckboxInputBgClr: '#474747',
  //loan list theme
  amountRepaid: '#148E6C',
  //loan details theme
  headingTitile: '#2D3748',
  addPaymentInputClr: '#F6F8FC',
  addPaymentLabeltClr: '#28242499',
  addPaymentDatePickerBorderClr: '#ACAEB033',
  datePickerLabelPopup: '#7182A0',
  masterdatacardBg: '#F2F0F0',
  masterdatacardBorder: 'rgba(112, 112, 112, 0.38)',
  masterdatacardLabel: 'rgba(160, 174, 192, 1)',
  masterdatacardLabelVal: 'rgba(45, 55, 72, 1)',
  masterdataSummarySvgBg: 'rgba(217, 220, 222, 1)',
  masterdataSummarySvgBoxShadow: 'rgba(0, 0, 0, 0.02)',
  masterdataSummaryActiveBg: '#edf2f6',
  masterdataSummaryMobActiveBg: 'rgba(11, 11, 11, 1)',
  masterdataSummaryMobSvgBorder: 'rgba(71, 71, 71, 1)',
  searchBoxBorder: 'rgba(166, 181, 206, 1)',
  searchBoxPlaceholder: '#12121275',
  searchBoxMobPlaceholder: '#a1a1aa',

  //masterData theme
  masterDatalabelClr: 'rgba(0, 0, 0, 0.56)',
  masterDataSublimitTitleClr: 'rgba(167, 167, 167, 1)',

  //AddNewUser
  addNewUserBtnClr: '#666',
  addNewUserBtnHowerClr: '#333',

  // LC theme
  convertedTableFontColor: 'rgba(32, 155, 255, 1)',

  // Notification theme
  viewAllTxtClr: 'rgba(0, 0, 0, 1)',
  contentWrapperBrdrTopClr: 'rgba(236, 236, 236, 1)',
  mainWrapperBgClr: 'rgba(255, 255, 255, 1)',
  mainWrapperBoxShadowClr: 'rgba(15, 15, 15, 0.2)',
  notificationTitleCLr: 'rgba(55, 53, 47, 1)',
  notificationCountBgClr: 'rgba(235, 87, 87, 1)',
  notificationCountClr: 'rgba(255, 255, 255, 1)',
  notificationCntentWrapperClr: 'rgba(157, 156, 154, 1)',
  actionTakenDetailsClr: 'rgba(48, 47, 42, 1)',
  unreadedCircleBg: 'rgba(0, 119, 216, 1)',
  notificationCntntWraper: '#ececec',
  timeContentClr: 'rgba(151, 150, 148, 1)',
  userNameTextClr: 'rgba(48, 47, 42, 1)',
  notificationHomeIconBg: '#d9d9d9',
  notificationHomeClr: 'rgba(0, 0, 0, 1)',
  notificationActionTakenClr: 'rgba(51, 51, 66, 1)',
  buttonBrdrClr: 'rgba(222, 222, 221, 1)',
  buttonClr: 'rgba(55, 53, 47, 1)',
  buttonHvrClr: '#f5f6f6',
  notificationPageBorderClr: 'rgba(241, 244, 249, 1)',
  transactionHistoryDebitClr: '#d84b4e',
  transactionHistoryCreditClr: '#148e6c',
  tableBgClr: '#f5f6f6',
};

const darkTheme: Theme = {
  white: '#ffffff',
  black: '#000000',
  tilesTitleClr: '#a0aec0',
  tilesValueClr: '#2d3748',
  sublimitIconClr: '#88ECC9',
  upcomingRenewalsIconClr: '#A3C0FF',
  activeIconClr: '#A6DDFF',
  expiredIconClr: '#E4D0FF',
  closedIconClr: '#FFB1B1',
  summaryCardBoxShadow: '#00000005',
  blackButtonHoverColor: '#535353',
  deleteBtnClr: '#ED5F5F',
  deleteBtnHvrClr: '#F60606',
  //DropDownThemeColors
  dropDownLabelColor: '#475467',
  dropDownRequiredColor: '#f44336',
  dropDownBorderColor: '#a3a3a3',
  dropDownFocusBorderColor: '#2563eb',
  dropDownMenuBorderColor: '#e5e7eb',
  dropDownPlaceholderColor: '#9ca3af',
  dropDownBackGroundColor: '#dee4ea',
  dropDownMenuScrollThumbColor: '#dee4ea',
  //dropdownend
  viewBtnBg: '#A6B5CE',
  saveBtnBg: '#3085fe',
  saveBtnHoverBg: '#09659f',
  saveBtnHoverBorderColr: '#5fb7ff',
  addSubmitBtnBG: '#209bff',
  uploadBlackBtnBorderColr: '#838181',
  uploadBlackBtnBg: '#f9fafb',
  blackHoverBtnBg: '#fffdfd', // Added this property
  deleteBg: '#ed5f5f',
  deleteHoverBg: '#FF4E4E',
  deleteHoverBorderClr: '#ff7e7e',
  clearBtnClr: '#040404',
  exportBtnBorderColr: '#1f1919',
  UploadDocBoderClr: '#A6B5CE',
  UploadDocBoderHoverClr: '#7070708F',
  viewbtnHoverClr: '#E7EAF0',
  exportBtnHoverBg: '#535353',
  exportBtnTextClr: '#535353',
  greyBtnTextClr: '#474747',
  datePickerBorderClr: '#e2e8f0',
  errorStarRed: '#f90b0b',
  datePickerTitle: '#2d3748',
  datePickerNonActiveInputClr: '#2D3748',
  datePickerDisabledInputClr: '#101828',
  calendarDaysClr: '#212529',
  calendarDaysClrHvr: '#eeeeee',
  calendarDaysHeaderClr: '#6c757d',
  calendarActiveClr: '#0d6efd',
  datepickerInnerClr: '#101828',
  datepickerInputSpan: 'rgb(28 28 28)',
  datepickerSrvValidationMsg: 'rgb(244 67 54)',
  calendarPopupInfinitBoxShadowClr: 'rgb(255 255 255)',
  disabledBrdrClr: '#e2e8f0',
  disabledBgClr: '#fafafa',
  popupTextareaLabel: '#7182a0',

  //Table grid theme start
  tableBg: 'rgba(255, 255, 255, 1)',
  tableHeadBorder: 'rgba(226, 232, 240, 1)',
  tableHeadText: 'rgba(160, 174, 192, 1)',
  tableTrEvenBg: 'rgb(245 246 246)',
  white81: 'rgb(255 255 255 / 81%)',
  tableCommonText: 'rgba(45, 55, 72, 1)',
  tablePaginationColor: '#7593CF',
  tablePaginationBg: '#1e253e',
  tablePaginationSelectedBorder: '#fc8f00',
  tablePaginationSelectedColor: '#ffffff',
  expandedGridBg: 'rgba(230, 230, 230, 1)',
  expandedGridHeadBorder: 'rgba(211, 211, 211, 1)',
  expandedGridHeadColor: 'rgba(149, 149, 150, 1)',
  expandedGridHeadInnerColor: '#959596',
  expandedGridEvenBg: 'rgba(223, 223, 223, 1)',
  paginationButtonBorder: '#e9e9e9',
  paginationGoButtonBorder: '#ccc',
  paginationGoButtonBg: '#f5f5f5',
  paginationInfoText: '#000000',
  gridCommonBorder: '#e5eef3',
  gridScrolltrack: '#323542',
  gridScrollthumb: '#828492',
  gridContentStickyBorder: '#3a2d4c',

  //table theme end

  summaryCardBoxShadowV2: 'rgba(0, 0, 0, 0.15)',
  summaryCardBrdrClrV2: '#f2f3f3',
  tilesTitle: 'rgba(104, 104, 104, 1)',
  tilesActiveClr: 'rgba(54, 192, 137, 1)',
  tilesExpiredClr: '#ED5F5F',
  tilesInactiveClr: 'rgba(237, 95, 95, 1)',
  summaryTilesSvgBg: 'rgba(242, 242, 242, 1)',
  //Checkbox theme colors
  checkBoxBackGroundColor: '#3085fe',
  checkBoxBorderColor: '#00000040',
  checkBoxFocusBorderColor: '#0000ff',
  checkBoxCheckBorderColor: '#6dc5ce ',
  //Checkbox theme colors end

  cancelButtonTxtClr: '#A0AEC0',
  warningPopupIcnBg: '#F5F7F8',
  warningPopupMainTitleClr: '#282424',
  warningPopupReasonClr: '#7182A0',
  discardBgHvrClr: '#433E3E',
  discardCancelBtnBgHvr: '#433E3E',
  warningPopupIconBrdrClr: '#EAEEF2',
  textareaPlaceholder: 'rgba(181, 181, 181, 1)',
  //NavBar Theme Colors
  navBarBorderColor: '#eaecf0',
  navBarLabelColor: '#0458ff',
  navBarDefaultBgColor: '#c4c4c440',
  navBarOnlineColor: '#12b76a',
  //NavBar Theme Colors end

  //LayOut Theme Colors
  layoutPageScrollColor: '#ebe8e8',
  layoutPageScrollThumbColor: '#d2d3d9',
  //LayOut Theme Colors end

  //Sidebar Theme Colors
  sideBarBorderColor: '#eaecf0',
  sideBarSearchWrapperBorderClr: '#d0d5dd',
  sideBarSelectedItemBgClr: '#efefef',
  sideBarItemTextClr: '#292929',
  //Sidebar Theme Colors end

  // table grid theme colors
  tableGridStatusGreen: '#36C089',
  sublimitCardBg: 'rgba(230, 230, 230, 1)',
  sublimitCardBrdrClr: '#e5f0ff',
  mainCardBg: 'rgba(245, 246, 246, 1)',
  mainCardBrdr: '#aaaaaa',
  //pieChart Theme Colors
  pieChartBorderClr: '#e5eef3',
  pieChartLableClr: '#2d3748',
  pieChartSliceBlueClr: '#3B00ED',
  pieChartSliceGreyClr: '#D9D9D9',
  pieChartGreenClr: '#36C089',
  pieChartBoxShadowClr: 'rgba(0, 0, 0, 0.05)',
  //pieChart Theme Colors end

  //Text field theme
  textFieldTextColor: '#292929',
  textFieldBorderColor: '#caced8',

  //Text field theme end

  //Add Facility Page
  addFacilityBackGroundColor: '#F9FAFB',
  addFacilityBorderColor: '#e5eef3',
  addFacilityBoxShadowColor: '#00000005',
  addFacilityHeaderTitleColor: '#101828',
  addFacilityHeaderSubTitleColor: '#475467',
  addFacilityHeaderBorderColor: '#E2E8F0',

  //Add Facility Page end
  //Common field theme
  textFieldDisableTextColor: '#A0AEC0',
  //Common field theme end
  //multiselect field theme start
  multiSelectBorderClr: '#a6b5ce',
  multiCheckBoxBorder: '#7182a0',
  multiSelectContainerBorderClr: '#ACBAD1',
  listBgClr: '#fffdfd',
  listHoverClr: '#dbd8d8 ',
  searchInputClr: '#475467',
  selectCountSpanClr: '#ffffffb0',
  //multiselect field theme end

  //Upload document theme
  uploadDocumentBgColor: '#d7dee3',
  uploadDocumentBoxShadowColor: '#00000040',
  uploadDocumentTitleColor: '#282424',
  uploadDocumentFileUploadBgColor: '#ececec',
  uploadDocumentFileUploadBtnColor: '#4a4a4a',
  uploadDocumentFileUploadImageBgColor: '#d9d9d9',
  uploadDocumentFileUploadTypeColor: '#575353',
  uploadDocumentFileUploadSizeColor: '#5753538a',
  uploadDocumentDropDownBorderColor: '#a6b5ce',
  uploadDocumentDropDownContentColor: '#474747',
  //Upload document theme end
  //Custom Toast theme
  errorBgClr: '#fdedef',
  errorBrdrClr: '#ea3e2f',
  successBgClr: '#b6eacd',
  successBrdrClr: '#00b152',
  warningBgClr: '#fde5c6',
  warningBrdrClr: '#f6a829',
  infoBgClr: '#c2edfe',
  infoBrdrClr: '#0267ee',
  // tooltip theme
  tooltipBgClr: '#181b32',
  statusActive: '#36C089',
  statusInActive: '#323232',
  statusClosed: '#ED5F5F',
  statusOverDue: '#eb8510',

  //skelton loader
  skeletonBaseColor: '#b7bdbe2b',
  skeletonHighlightColor: '#f5f5f58f',
  //skelton loader end
  //Facility Card View
  cardBorderClr: '#e5eef3',
  cardLabelClr: '#718096',
  cardValueClr: '#2d3748',
  cardTotalAmountClr: '#148e6c',
  boxShadowClr: '#00000005',
  uploadDocumentLableClr: '#209BFF',
  infoLabelClr: '#acacac',
  tabTextClr: '#101317',
  tabBorderClr: '#e5eef3',
  tabBoxShadowClr: '#00000040',
  facilityDetailsCardBxShadowClr: 'rgba(0, 0, 0, 0.25)',
  //mobileAddFacility Theme
  mobileAddFacilityTitleClr: '#292D32',
  mobileAddFacilitySubTitleClr: '#475467',
  //mobileAddFacility Theme end

  //custom date-range picker dark theme start
  customDateRangeSelectorBg: 'rgba(255, 255, 255, 1)',
  customDateRangeSelectorTxtClr: '#D2D2D2',
  customDateRangeSelectorValueTxtClr: '#FFFFFF',
  customDateRangeSelectorWeekDays: 'rgba(115, 115, 115, 1)',
  customDateRangeSelectorDays: '#A6A6A6',
  customDateRangeSelectorNeighboringMonthDays: '#667085',
  customDateRangeSelectorDaysHvr: '#0000000a',
  customDateRangeSelectorValueBrdrClr: '#28304D',
  customDateRangeSelectorBrdrClr: '#28304D',
  customDateRangeSelectorButtonBrdrClr: '#424C71',
  customDateRangeSelectorButtonClr: '#F1F1F1',
  customDateRangeSelectorButtonHvrBgClr: '#1C264C',
  customDateRangeSelectorButtonHvrClr: '#1D2939',
  customDateRangeSelectorButtonSecndBgClr: 'rgba(0, 0, 0, 1)',
  customDateRangeSelectorButtonSecndClr: '#FFFFFF',
  customDateRangeSelectorButtonSecndHvrBgClr: '#2e2a2a',
  customDateRangeSelectorBorder: '#28304D',
  customDateRangeSelectorHyphenClr: '#9A9A9A',
  customDateRangeSelectorTodayDot: '#3085FE',
  customDateRangeSelectorActiveTileBg: 'rgba(204, 204, 204, 1)',
  customDateRangeSelectorTileFocusedClr: '#FFFFFF',
  customDateRangeSelectorTileActiveClr: '#FFFFFF',
  customDateRangeOverViewDateRangeBrdrClr: '#282828',
  customDateRangeOverViewDateRangeClr: '#7d7d7d',
  customDateRangeOverViewDateRangeIconClr: '#e4e4e4',
  customDateRangeCancelBtnClr: '#000000',
  customDateRangeCancelBtnBorderClr: '#D9D9D9',
  customDateRangeNavTextColor: '#000000',
  customDateRangeMainBg: 'rgba(255, 253, 253, 1)',
  customDateRangeMainBorder: 'rgba(166, 181, 206, 1)',
  customDateRangeMainSelectedBg: '#000000',
  customDateRangeMainSelectedColor: '#fff',
  customDateRangeFooterColor: '#000000',
  customDateRangeCalenderBorder: '#0000001a',
  customDateRangeDateValueBg: '#fafafa',
  customDateRangeDateValueBorder: '#cccccc',
  customDateRangeDateValueColor: '#000000',
  customDateRangeNavBorder: '#e3e0e0',
  customDateRangeCancelBtnHvrBg: '#F5F5F5',
  //custom date-range picker dark theme end

  // Facility list
  facilityListToggleBtn: '#1d1c1c',
  facilityListWelcomeBrdrClr: '#e5eef3',
  facilityListLabelClr: '#2D3748',
  facilityListMobileBrdrBtmClr: '#e2e8f0',

  //history list starts
  historyNameClr: '#2D3748',
  actionLableClr: '#0b65ff',
  timeLableClr: '#a0aec0',
  lineBackgroundClr: '#E2E8F0',
  detailsBorderClr: '#e1e3e8 ',
  historyBorderClr: '#e5eef3',
  historyBoxShadow: 'rgba(0, 0, 0, 0.05)',
  mobileTimeLableClr: '#565973',
  linearGradientClr:
    '90deg, rgba(224, 225, 226, 0) 0%, #E0E1E200 49.52%, rgba(224, 225, 226, 0.15625) 99.04%',
  //history list ends

  //expiry alert starts
  alertBackgroundClr: '#fa0e0e14',
  alertBorderClr: '#ff2b2b80',
  alertlabelClr: '#ed3a3a',
  //expiry alert ends
  detailCardBackGroundClr: '#F9F9F9',

  //mobilefacilitylistchary theme start
  chartBorder: '#8e8e8e',
  headingColor: '#acacac',
  chartParaColor: '#2d3748',
  backdropBg: 'rgb(0 0 0 / 65%)',
  chartBefore: '#dddd',
  chartAfter: '#e2e8f0',
  chartTitle: '#a0aec0 ',
  chartAmount: '#039c5f',
  chartTrackBg: '#D7D9DB',
  chartLabelColor: '#000',
  mobileFundedChartColor: '#3B00ED',
  mobileNonFundedChartColor: '#36C089',
  //mobilefacilitylistchary theme end

  //HISTORY DETAILS PAGE START
  historyMobileCardBg: '#f8fbff',
  historyMobileCardBrdrClr: 'rgba(112, 112, 112, 0.38)',
  histroyDetailsTblHderBg: '#f5f6f6',
  historyDetailsValueClr: 'rgba(45, 55, 72, 1)',
  historyDetailsTdBrdrClr: 'rgba(226, 232, 240, 1)',
  //HISTORY DETAILS PAGE END

  // Addloan theme
  addInstallmentBtnBorder: '#3085FE',
  addInstallmentBtnText: '#3085FE',
  addInstallmentBtnBg: '#F9FAFB',
  customDateSplitText: 'rgba(0, 0, 0, 0.93)',
  customDateGridheader: 'rgba(246, 248, 252, 1)',
  customDateGridTdBorder: 'rgba(226, 232, 240, 1)',
  customDateGridTdEvenBg: 'rgba(246, 248, 252, 1)',
  customDateGridTdOddBg: 'rgba(249, 250, 251, 1)',
  styledCardBg: 'rgba(248, 251, 255, 1)',
  styledCardBgBorder: 'rgba(112, 112, 112, 0.38)',
  styledCardLabel: 'rgba(172, 172, 172, 1)',
  styledFieldBlueBorder: '#209bff',
  styledFieldDisabledBorder: 'rgba(226, 232, 240, 1)',
  styledFieldReadOnlyBorder: 'rgba(226, 232, 240, 1)',

  //close loan popu
  closeLoanTitleClr: 'rgba(0, 0, 0, 1)',
  closeLoanCheckboxButtonBg: 'rgba(248, 248, 248, 1)',
  closeLoanCheckboxLabelClr: 'rgba(0, 0, 0, 1)',
  closeLoanCheckboxInputBgClr: '#474747',
  //loan list theme
  amountRepaid: '#148E6C',
  //loan details theme
  headingTitile: '#2D3748',
  addPaymentInputClr: '#F6F8FC',
  addPaymentLabeltClr: '#28242499',
  addPaymentDatePickerBorderClr: '#ACAEB033',
  datePickerLabelPopup: '#7182A0',
  masterdatacardBg: '#F2F0F0',
  masterdatacardBorder: 'rgba(112, 112, 112, 0.38)',
  masterdatacardLabel: 'rgba(160, 174, 192, 1)',
  masterdatacardLabelVal: 'rgba(45, 55, 72, 1)',
  masterdataSummarySvgBg: 'rgba(217, 220, 222, 1)',
  masterdataSummarySvgBoxShadow: 'rgba(0, 0, 0, 0.02)',
  masterdataSummaryActiveBg: '#edf2f6',
  masterdataSummaryMobActiveBg: 'rgba(11, 11, 11, 1)',
  masterdataSummaryMobSvgBorder: 'rgba(71, 71, 71, 1)',
  searchBoxBorder: 'rgba(166, 181, 206, 1)',
  searchBoxPlaceholder: '#12121275',
  searchBoxMobPlaceholder: '#a1a1aa',

  //masterData theme
  masterDatalabelClr: 'rgba(0, 0, 0, 0.56)',
  masterDataSublimitTitleClr: 'rgba(167, 167, 167, 1)',

  //AddNewUser
  addNewUserBtnClr: '#666',
  addNewUserBtnHowerClr: '#333',

  // LC theme
  convertedTableFontColor: 'rgba(32, 155, 255, 1)',

  // Notification theme
  viewAllTxtClr: 'rgba(0, 0, 0, 1)',
  contentWrapperBrdrTopClr: 'rgba(236, 236, 236, 1)',
  mainWrapperBgClr: 'rgba(255, 255, 255, 1)',
  mainWrapperBoxShadowClr: 'rgba(15, 15, 15, 0.2)',
  notificationTitleCLr: 'rgba(55, 53, 47, 1)',
  notificationCountBgClr: 'rgba(235, 87, 87, 1)',
  notificationCountClr: 'rgba(255, 255, 255, 1)',
  notificationCntentWrapperClr: 'rgba(157, 156, 154, 1)',
  actionTakenDetailsClr: 'rgba(48, 47, 42, 1)',
  unreadedCircleBg: 'rgba(0, 119, 216, 1)',
  notificationCntntWraper: '#ececec',
  timeContentClr: 'rgba(151, 150, 148, 1)',
  userNameTextClr: 'rgba(48, 47, 42, 1)',
  notificationHomeIconBg: '#d9d9d9',
  notificationHomeClr: 'rgba(0, 0, 0, 1)',
  notificationActionTakenClr: 'rgba(51, 51, 66, 1)',
  buttonBrdrClr: 'rgba(222, 222, 221, 1)',
  buttonClr: 'rgba(55, 53, 47, 1)',
  buttonHvrClr: '#f5f6f6',
  notificationPageBorderClr: 'rgba(241, 244, 249, 1)',
  transactionHistoryDebitClr: '#d84b4e',
  transactionHistoryCreditClr: '#148e6c',
  tableBgClr: '#f5f6f6',
};

export type Theme = typeof lightTheme;

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
